import moment from "moment";
import { useEffect, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import API from "../../common/API";
import Settings from "../../common/Settings";

const RecordSalarios = (props: any) => {
    const { id } = props;
    const [records, setRecords] = useState<any>([]);
    const { t } = useTranslation();

    const bindRecords = async () => {
        try {
            const response = await API.getAction(`salario/list?cedula=${id}`);
            if (response.status === 200) {
                setRecords(response.data.response || []);
            } else {
                console.error("Error fetching salarios records:", response.statusText);
            }
        } catch (error) {
            console.error("Error fetching salarios records:", error);
        }
    }

    useEffect(() => {
        if (id) {
            bindRecords();
        }
    }
        , [id]);
    if (records.length === 0) {
        return null;
    }

    return (<>
        <Card className="my-4" >
            <Card.Header className="display-4">{t("Antecedentes Laborales")}</Card.Header>
            <Card.Body className="p-0">
                <div className="table-responsive">
                    <table className="table table-striped table-bordered">
                        <thead>
                            <tr>
                                <th>{t("Institución")}</th>
                                <th>{t("Fecha Salario")}</th>
                                <th>{t("Salario ISR")}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {records && records.map((item, index) => {
                                function formatMoney(salarioIsr: any): import("react").ReactNode {
                                    if (typeof salarioIsr !== "number") {
                                        return "-";
                                    }
                                    return salarioIsr.toLocaleString("es-DO", {
                                        style: "currency",
                                        currency: "DOP",
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                    });
                                }
                                return (
                                    <tr key={index}>

                                        <td>{index + 1}.&nbsp;{item.empleadorNombre}</td>
                                        <td>{moment(item.fechaSalario).format("MMM YYYY")}</td>
                                        <td>{formatMoney(item.salario)}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </Card.Body>
        </Card>
    </>
    );
};

export default RecordSalarios;